import { Linkedin, Twitter, Facebook, Link2, Check } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function SocialShare({ url, title, hashtags = ["culinaire", "chef", "highend"], testId = "social-share" }) {
  const [copied, setCopied] = useState(false);
  const absUrl = url.startsWith("http") ? url : `${window.location.origin}${url}`;
  const enc = encodeURIComponent;
  const links = {
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${enc(absUrl)}`,
    twitter: `https://twitter.com/intent/tweet?url=${enc(absUrl)}&text=${enc(title || "")}&hashtags=${enc(hashtags.join(","))}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${enc(absUrl)}`,
  };

  const open = (href) => () => window.open(href, "_blank", "noopener,noreferrer,width=680,height=560");

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(absUrl);
      setCopied(true);
      toast.success("Link copied");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Couldn't copy link");
    }
  };

  return (
    <div className="flex flex-wrap items-center gap-2" data-testid={testId}>
      <span className="label-eyebrow mr-1">Share</span>
      <Button size="sm" variant="outline" onClick={open(links.linkedin)} className="gap-1.5" data-testid={`${testId}-linkedin`}>
        <Linkedin className="w-3.5 h-3.5" /> LinkedIn
      </Button>
      <Button size="sm" variant="outline" onClick={open(links.twitter)} className="gap-1.5" data-testid={`${testId}-twitter`}>
        <Twitter className="w-3.5 h-3.5" /> X / Twitter
      </Button>
      <Button size="sm" variant="outline" onClick={open(links.facebook)} className="gap-1.5" data-testid={`${testId}-facebook`}>
        <Facebook className="w-3.5 h-3.5" /> Facebook
      </Button>
      <Button size="sm" variant="outline" onClick={copy} className="gap-1.5" data-testid={`${testId}-copy`}>
        {copied ? <Check className="w-3.5 h-3.5" /> : <Link2 className="w-3.5 h-3.5" />}
        {copied ? "Copied" : "Copy link"}
      </Button>
    </div>
  );
}
